import { useContext } from "react";
import { Link } from "react-router-dom";
import JobFilterContext from "../contexts/JobFilterContext";

export default function Sidebar() {
	const { setJobFilter } = useContext(JobFilterContext);

	const handleJobTypeFilter = (e, jobType) => {
		e.preventDefault();

		setJobFilter(jobType);
	}

	return (
		<div className="sidebar">
			<nav>
				<ul className="space-y-4">
					<li>
						<Link
							onClick={() => setJobFilter('')}
							to="/"
							className="main-menu menu-active lws-allJob"
						>
							<i className="fa-solid fa-briefcase"></i>
							<span> All Available Jobs</span>
						</Link>
						<ul className="space-y-6 lg:space-y-2 ">
							<li>
								<a onClick={(e) => handleJobTypeFilter(e, 'Internship')} className="sub-menu" href="/jobs/internship">
									<i className="fa-solid fa-stop !text-[#FF5757]"></i>{" "}
									Internship
								</a>
							</li>
							<li>
								<a onClick={(e) => handleJobTypeFilter(e, 'Full Time')} className="sub-menu" href="/jobs/fulltime">
									<i className="fa-solid fa-stop !text-[#FF8A00]"></i>{" "}
									Full Time
								</a>
							</li>
							<li>
								<a onClick={(e) => handleJobTypeFilter(e, 'Remote')} className="sub-menu" href="/jobs/remote">
									<i className="fa-solid fa-stop !text-[#56E5C4]"></i>{" "}
									Remote
								</a>
							</li>
						</ul>
					</li>
					<li>
						<Link to="/newjob" className="main-menu lws-AddJob">
							<i className="fa-solid fa-file-circle-plus"></i>
							<span> Add NewJob</span>
						</Link>
					</li>
				</ul>
			</nav>
		</div>
	);
}
